import _root_default from "./_root.js";

//#region ../../node_modules/lodash-es/_Uint8Array.js
/** Built-in value references. */
var Uint8Array = _root_default.Uint8Array;
var _Uint8Array_default = Uint8Array;

//#endregion
export { _Uint8Array_default as default };
//# sourceMappingURL=_Uint8Array.js.map